import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  change,
  clearFields,
  Field,
  formValueSelector,
  reduxForm,
} from 'redux-form';
import PropTypes from 'prop-types';

import containerWidth from '../../../../shared/helpers/containerWidth';
import getEnvironmentSuffix from '../../../../shared/helpers/getEnvironmentSuffix';
import {
  required,
  requiredDate, validateEmail,
} from '../../../../shared/libs/reduxFormValidations';
import InputCheckbox from '../../FormElements/Checkbox/CheckBox';
import DateInput from '../../FormElements/DateInput/DateInput';

import InputText from '../../FormElements/Input/Input';

import './SecondScreen.scss';

class SecondScreen extends Component {
  constructor() {
    super();
    this.handleIsAddressToMe = this.handleIsAddressToMe.bind(this);
  }

  componentDidMount() {
    const { handleLeavePage } = this.props;
    window.addEventListener('beforeunload', handleLeavePage);
  }

  handleIsAddressToMe(e) {
    const { dispatch, form } = this.props;
    const inputValue = e.target.value;
    if (inputValue === 'false' || !inputValue) {
      const addressedToName = `${window.UserFirstName} ${window.UserLastName}`;
      dispatch(change(form, 'addressedTo.companyName', addressedToName));
    } else {
      dispatch(clearFields(form, true, true, 'addressedTo.companyName'));
    }
  }

  render() {
    const {
      defaultDue,
      minDueDate,
      config,
      isAddressedToMe,
      isRush,
      handleSubmit,
      tatm,
    } = this.props;
    return (
      <form
        id="wizard-form"
        onSubmit={handleSubmit}
        className="row order_form_second needs-validation"
      >
        <div className={containerWidth}>
          <div className="row">
            <div className="col">
              <div className="order_form_second__paragraph">
                Standard turn around time is
                {' '}
                <strong>{minDueDate}</strong>
                {' '}
                days.
              </div>
              {tatm && tatm.length !== 0 ? (
              <div className="order_form_second__paragraph" style={{ whiteSpace: 'pre-wrap' }}>
                {tatm}
              </div>) :
              (<div className="order_form_second__paragraph">
                If you need it sooner, please select
                {' '}
                <strong>Rush</strong>
                {' '}
                and
                pick a date.
              </div>)}
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <Field
                name="dueDate"
                type="text"
                placeholder=" "
                component={DateInput}
                label="Date Needed"
                disabledBefore={isRush ? new Date() : defaultDue}
                required={config.dueDate?.r}
                validate={[].concat(config.dueDate?.r ? [requiredDate] : [])}
                hidden={config.dueDate?.h}
              />
            </div>
            <div className="col-6">
              <Field
                name="rush"
                component={InputCheckbox}
                label="Rush? (Extra fee MAY apply)"
                inputID="rushCheckbox"
                bemClass="inline-checkbox"
                hidden={config.rush?.h}
              />
            </div>
          </div>
          {!window.isAuthenticated && (
          <>
            <div className="row">
              <div className="col-auto">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="orderedBy">
                  Provide Your Information?
                  <span className="requiredField">*</span>
                </label>
                <span className="ml-1 mr-1">or</span>
                <a
                  href={`https://login${getEnvironmentSuffix()}.anow.com/?returnUrl=${window.location.href}`}
                  className="btn-link"
                >
                  login here
                </a>
              </div>
            </div>
            <Field
              name="orderedBy.name"
              type="text"
              placeholder="Full Name/Company Name"
              component={InputText}
              required
              inputID="orderedBy"
              validate={[required]}
            />
            <div className="row">
              <div className="col-6">
                <Field
                  name="orderedBy.email"
                  type="text"
                  placeholder="E-mail"
                  component={InputText}
                  required
                  validate={[required]}
                  warn={[validateEmail]}
                />
              </div>
              <div className="col-6">
                <Field
                  name="orderedBy.phone"
                  type="text"
                  placeholder="Phone Number"
                  component={InputText}
                  required
                  validate={[required]}
                />
              </div>
            </div>
          </>
          )}
          {!config.addressedToCompanyName?.h && (
          <div className="row">
            <div className="col-auto">
              <label htmlFor="addressToMe">
                Who is it for?
                {' '}
                {config.addressedToCompanyName?.r && (
                <span className="requiredField">*</span>
                    )}
              </label>
            </div>
            {window.isAuthenticated && (
            <div className="col">
              <Field
                name="addressToMe"
                component={InputCheckbox}
                label="Address this order to me"
                inputID="addressToMe"
                bemClass="inline-narrow-checkbox"
                onChange={this.handleIsAddressToMe}
              />
            </div>
            )}
          </div>
          )}
          <Field
            name="addressedTo.companyName"
            type="text"
            placeholder="Lender/Intended user"
            component={InputText}
            required={config.addressedToCompanyName?.r}
            validate={[].concat(config.addressedToCompanyName?.r ? [required] : [])}
            hidden={config.addressedToCompanyName?.h}
            disabled={isAddressedToMe}
          />
          <Field
            name="propertyOwner.companyName"
            type="text"
            placeholder="Name"
            component={InputText}
            label="Homeowner/Applicant/Borrower Name"
            skipTouchedValidation
            required={config.propertyOwnerCompanyName?.r}
            validate={[].concat(config.propertyOwnerCompanyName?.r ? [required] : [])}
            hidden={config.propertyOwnerCompanyName?.h}
          />
          <div className="row">
            <div className="col-6">
              <Field
                name="propertyOwner.email"
                type="text"
                placeholder="E-mail"
                component={InputText}
                required={config.propertyOwnerEmail?.r}
                validate={[].concat(config.propertyOwnerEmail?.r ? [required] : [])}
                hidden={config.propertyOwnerEmail?.h}
                warn={[validateEmail]}
              />
            </div>
            <div className="col-6">
              <Field
                name="propertyOwner.phone"
                type="text"
                placeholder="Phone Number"
                component={InputText}
                required={config.propertyOwnerPhone?.r}
                validate={[].concat(config.propertyOwnerPhone?.r ? [required] : [])}
                hidden={config.propertyOwnerPhone?.h}
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}

SecondScreen.propTypes = {
  isAddressedToMe: PropTypes.bool,
  isRush: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  defaultDue: PropTypes.string,
  config: PropTypes.objectOf(PropTypes.shape({
    r: PropTypes.bool,
    h: PropTypes.bool,
  })).isRequired,
  form: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  minDueDate: PropTypes.number,
  handleLeavePage: PropTypes.func.isRequired,
};
SecondScreen.defaultProps = {
  defaultDue: null,
  isAddressedToMe: false,
  isRush: false,
  minDueDate: 0,
};

const selector = formValueSelector('WizardOrderForm');

const ReachSecondScreen = connect((state) => {
  const isAddressedToMe = selector(state, 'addressToMe');
  const isRush = selector(state, 'rush');

  return {
    isAddressedToMe,
    isRush,
  };
})(SecondScreen);

export default reduxForm({
  form: 'WizardOrderForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: (values) => {
    const errors = {};
    const { propertyOwner } = values;
    if (
      (propertyOwner?.email || propertyOwner?.phone)
      && !propertyOwner?.companyName
    ) {
      errors.propertyOwner = {
        companyName: 'Borrower name is required',
      };
    }
    return errors;
  },
})(ReachSecondScreen);
